import React from 'react'

import queryString from 'query-string'

import { Portlet } from '_zari/core'

import { CodigosTransaccionesConstant, OrigenesContabilidadConstant } from 'constants/index'

import { IdGen } from 'utils'

import MainForm from './mainForm'

const NuevoOgCobrPage = ({ location }) => {
  const [_mainFormKey, setMainFormKey] = React.useState(IdGen.newId())

  const portletBreadcrumbs = React.useMemo(() => {
    let { origen } = queryString.parse(location.search)

    const nombreOrigen = OrigenesContabilidadConstant.__dictionary[origen].nombre

    return [
      {
        name: 'Asientos Contables',
        path: `/${CodigosTransaccionesConstant.ASIENTOSCONTABLES_LISTA}`
      },
      { name: `Origen ${nombreOrigen}` }
    ]
  }, [location.search])

  const resetMainForm = React.useCallback(() => {
    setMainFormKey(IdGen.newId())
  }, [])

  return (
    <Portlet>
      <Portlet.Header title='Asientos Contables' breadcrumbs={portletBreadcrumbs} />
      <Portlet.Body>
        <MainForm key={_mainFormKey} resetMainForm={resetMainForm} />
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(NuevoOgCobrPage)
